<template>
  <div v-if="roleRules.indexOf('SJB_P_0006') !== -1" class="toolbar-item">
    <span class="demonstration">子账号</span>
    <el-select v-model="intermediary" placeholder="请选择" clearable @change="changeSelect" @clear="clear">
      <el-option v-for="(item, idx) in roleArr" :label="item.userName" :value="item.userCode" :key="idx"> </el-option>
    </el-select>
  </div>
</template>

<script>
import api from '@/api/order.new.api';
import axios from '@/api/axiosNew';
import { WUYI, vali } from '@/api/common';

export default {
  name: 'Intermediary',
  data() {
    return {
      intermediary: '',
      roleRules: WUYI.currentData.userrole,
      roleArr: []
    };
  },
  created() {
    // 获取下单人
    if (this.roleRules.indexOf('SJB_P_0006') !== -1) {
      axios.post(api.orderDataQueryPermissionUser).then(res => {
        this.roleArr = res.data;
      });
    }
  },
  methods: {
    changeSelect(val) {
      this.$emit('changeValue', val);
    },
    clear() {
      this.$emit('changeValue', '');
    }
  }
};
</script>
